import { WANDERS_API, KORBAN_API } from '@config/endpoints';

export const MENU_LINKS = [
    {
        text: 'menu-explore',
        link: '/',
        customClass: 'NavSubMenu',
        submenu: [
            {
                text: 'menu-style-quiz',
                link: WANDERS_API + '/quiz',
            },
            {
                text: 'menu-about-us',
                link: '/about-us',
            },
            {
                text: 'menu-our-process',
                link: '/our-processes',
            },
            {
                text: 'menu-packages',
                link: '/our-packages',
            },
            {
                text: 'menu-gifts',
                link: '/our-gift-packages',
            },
            {
                text: 'menu-faq',
                link: '/faq',
            },
        ],
    },
    {
        text: 'menu-my-projects',
        link: WANDERS_API + '/my-projects',
        customClass: 'MyProjects',
        view: 'post',
    },
    {
        text: 'menu-welcome',
        link: '#',
        customClass: 'WelcomeSubMenu',
        action: 'session',
        view: 'post',
        submenu: [
            {
                text: 'my-account',
                link: '/user',
                view: 'post',
                customClass: 'MyAccountLink',
            },
            {
                text: 'menu-admin',
                link: KORBAN_API + '/project-tracking',
                view: 'post',
                action: 'admin',
                customClass: 'AdminLink',
            },
            {
                text: 'menu-logout',
                link: '#',
                customClass: 'LogoutLink',
                action: 'logout',
                view: 'post',
            },
        ],
    },
    {
        text: 'menu-sign-up',
        link: '#',
        customClass: 'SignupLink NoSpacesAfter',
        action: 'signup',
        view: 'pre',
    },
    {
        text: '|',
        link: '#',
        customClass: 'LoginSeparator font-bold hidden lg:flex',
        view: 'pre',
    },
    {
        text: 'menu-login',
        link: '#',
        customClass: 'LoginLink NoSpacesBefore',
        action: 'login',
        view: 'pre',
    },
];
